import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer';
import { Helmet } from "react-helmet-async";

export default function Gmfindia() {
  return (
    <>
    <Helmet>
      <title>GMF India | Gandhi Mandela Foundation</title>
    </Helmet>
    <Header/>
        <section className="page-header">
            <div className="container">
                <div className="breadcrumb">
                    <a href="/">Home</a>
                    <span>/</span>
                    <span>GMF India</span>
                </div>
                <h1>GMF India</h1>
            </div>
        </section>
        {/* =========================
            BOARD MEMBERS
        ========================= */}
        <section className="board-members">
        <div className="container">
            <div className="members-grid">
            <div className="member-card">
                <div className="member-img">
                <img src="img/members/shyam-jaju.jpg" alt="SHYAM JAJU" />
                </div>
                <h3>SHYAM JAJU</h3>
                <span>(NATIONAL PRESIDENT)</span>
            </div>
            {/*<div class="member-card">
                <div class="member-img">
                    <img src="assets/img/members/Acharya-Lokesh-Muni.jpg" alt="ACHARYA LOKESH MUNI">
                </div>
                <h3>ACHARYA LOKESH MUNI</h3>
                <span>VICE CHAIRMAN</span>
            </div>

            <div class="member-card">
                <div class="member-img">
                    <img src="assets/img/members/savita-singh.jpg" alt="DR. SAVITA SINGH">
                </div>
                <h3>DR. SAVITA SINGH</h3>
                <span>VICE PRESIDENT</span>
            </div>-*/}
            </div>
        </div>
        </section>
        {/* =========================
        FOOTER
        ========================== */}
    <Footer/>
    </>
  )
}
